import './KeybindingHint-0856c11b.css';

var classes = {"KeybindingHint":"prc-KeybindingHint-KeybindingHint-0pyit"};

export { classes as default };
